import React, { createContext, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const LocationContext = createContext();

export const usePreviousLocation = () => {
  return useContext(LocationContext);
};

const LocationProvider = ({ children }) => {
  const location = useLocation();
  const prevLocationRef = useRef(null);

  React.useEffect(() => {
    // Check if the pathname contains 'create' or 'edit' and skip updating the ref if it does
    if (
      !location.pathname.includes('create') &&
      !location.pathname.includes('edit')
    ) {
      prevLocationRef.current = location.pathname;
    } else {
      prevLocationRef.current = null;
    }
  }, [location]);

  return (
    <LocationContext.Provider value={prevLocationRef.current}>
      {children}
    </LocationContext.Provider>
  );
};

export default LocationProvider;
